import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from '../token/token.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(public http: HttpClient, private tokenService: TokenService) {}

  GetVinInfo(vehicle_id: object) {
    return this.http.post(
      `${environment.api}/car/information/get/vehicle-information`,
      vehicle_id
    );
  }
  // //-----Debasish new api method--------//
  // NewGetVinInfo() {
  //     return this.http.get(
  //       `${environment.api}/car/information/get/vehicle-information`);
  // }

  PostVinInfo(vinInfo: Object) {
    return this.http.post(`${environment.api}/car/vin-information`, vinInfo);
  }

  vinSearch(vinInfo: Object) {
    return this.http.post(`${environment.api}/car/get/duplicate-vin`, vinInfo);
  }

  PostValidation(validation: Object) {
    return this.http.post(
      `${environment.api}/car/vin-verification`,
      validation
    );
  }

  GetFlags() {
    return this.http.get(`${environment.api}/car/get/vehicle-flags`);
  }

  SaveFlags(data: Object) {
    return this.http.post(
      `${environment.api}/car/add/vehicle-flags-data-info`,
      data
    );
  }

  GetOptions() {
    return this.http.get(`${environment.api}/car/get/vehicle-options`);
  }

  SaveOptions(data: Object) {
    return this.http.post(
      `${environment.api}/car/add/vehicle-options-data-info`,
      data
    );
  }

  GetEstimatorList(vehicle_id: Object) {
    return this.http.post(`${environment.api}/car/list/estimator`, vehicle_id, {
      headers: this.tokenService.GetTokenByHeader(),
    });
  }

  AddEstimator(data: object) {
    return this.http.post(`${environment.api}/car/add/estimator`, data, {
      headers: this.tokenService.GetTokenByHeader(),
    });
  }

  DeleteEstimator(data: object) {
    return this.http.post(`${environment.api}/car/delete/estimator`, data, {
      headers: this.tokenService.GetTokenByHeader(),
    });
  }
}
